import { useNavigate } from "react-router-dom";
import useIsMobile from "../hooks/useIsMobile";
import { openExplorer } from "./Header";

// export const logoImg =
//   "https://getcelerapp.s3.us-west-1.amazonaws.com/brevis-website/images/logo.svg?" +
//   new Date().getTime();
import logoImg from "../imgs/logo-white.svg";
const picoZkVMDocs = "https://pico-docs.brevis.network/";
const zkCoprocessorDocs = "https://coprocessor-docs.brevis.network/";
export const openPicoDoc = () => {
  window?.open(picoZkVMDocs, "_blank");
};
export const openZkDoc = () => {
  window?.open(zkCoprocessorDocs, "_blank");
};
export const openBlog = () => {
  window?.open("https://blog.brevis.network/", "_blank");
};
const Footer = () => {
  const year = new Date().getFullYear();
  const { isMobile } = useIsMobile();
  const history = useNavigate();

  const resources = [
    {
      text: "Github",
      link: " https://github.com/brevis-network/",
    },
    {
      text: "Pico zkVM Docs",
      link: picoZkVMDocs,
    },
    {
      text: "zkCoprocessor Docs",
      link: zkCoprocessorDocs,
    },
  ];
  const contacts = [
    {
      text: "Talk to a builder",
      link: "https://form.typeform.com/to/lduiliob",
    },
    {
      text: "Join Discord",
      link: "https://discord.com/invite/QTRkjKdZ6A",
    },
    {
      text: "Career",
      link: "https://jobs.ashbyhq.com/brevis-network",
    },
  ];
  return (
    <div className="footer">
      <div className="footer_body">
        <div className="footer_level">
          <div className="footer_left">
            <img
              src={logoImg}
              className="footer_img"
              alt=""
              onClick={() => {
                window.scrollTo(0, 0);
              }}
            />
            {!isMobile && (
              <div className="footer_reserved">
                © Brevis {year}. All rights reserved.
              </div>
            )}
          </div>
          <div className="footer_right">
            <div className="footer_resources">
              <div className="footer_resourcesText">Products</div>
              <div
                className="footer_link_item"
                onClick={() => {
                  openPicoDoc();
                }}
              >
                Pico zkVM
              </div>
              <div
                className="footer_link_item"
                onClick={() => {
                  openZkDoc();
                }}
              >
                zkCoprocessor
              </div>
              <div
                className="footer_link_item"
                onClick={() => {
                  openExplorer();
                }}
              >
                Explorer
              </div>
            </div>
            <div className="footer_resources">
              <div className="footer_resourcesText">Discover</div>
              <div
                className="footer_link_item"
                onClick={() => {
                  history("/ecosystem");
                }}
              >
                Ecosystem
              </div>
              <div
                className="footer_link_item"
                onClick={() => {
                  openBlog();
                }}
              >
                Blog
              </div>
              <div
                className="footer_link_item"
                onClick={() => {
                  window?.open("https://twitter.com/brevis_zk", "_blank");
                }}
              >
                X (Twitter)
              </div>
            </div>

            <div className="footer_resources">
              <div className="footer_resourcesText">Build</div>
              {resources.map((item, index) => {
                return (
                  <div
                    key={index}
                    className="footer_link_item"
                    onClick={() => {
                      window?.open(item.link, "_blank");
                    }}
                  >
                    {item.text}
                  </div>
                );
              })}
            </div>
            <div className="footer_contactUs">
              <div className="footer_resourcesText2">Contact Us</div>
              {contacts.map((item, index) => {
                return (
                  <div
                    key={index}
                    className="footer_link_item"
                    onClick={() => {
                      window?.open(item.link, "_blank");
                    }}
                  >
                    {item.text}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        {isMobile && (
          <div className="footer_reserved">
            © Brevis {year}. All rights reserved.
          </div>
        )}
      </div>
    </div>
  );
};
export default Footer;
